import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const EditFlashcardModal = ({ isOpen, toggle, card, onSuccess }) => {
  const [frontText, setFrontText] = useState("");
  const [script, setScript] = useState(card.format_coching_script || "");
  const [saving, setSaving] = useState(false);
  // Only set when a new image is uploaded (raw S3 filename, not full URL)
  const [imageName, setImageName] = useState("");
  const [previewImage, setPreviewImage] = useState(card?.image_name || "");
  const [uploadingImage, setUploadingImage] = useState(false);
  const [removeImage, setRemoveImage] = useState(false);

   const normalizeScriptToHTML = (raw = "") => {
    return raw
        ?.replace(/\\r\\n|\\n|\\r/g, "")
        ?.replace(/\\'/g, "'")
        ?.replace(/\\"/g, '"');
    };



  const editor = useEditor({
    extensions: [StarterKit],
    content: "",
    onUpdate({ editor }) {
        setScript(editor.getHTML());
    }
    });


  useEffect(() => {
    if (isOpen && card && editor) {
        setFrontText(`${card.item_name} - ${card.course_name}`);

        const html = normalizeScriptToHTML(card.format_coching_script || "");
        editor.commands.setContent(html);
        setScript(html);

        setImageName("");
        setPreviewImage(card.image_name || "");
        setRemoveImage(false);
        setUploadingImage(false);
    }
    }, [isOpen, card, editor]);

  const uploadImage = async (file) => {
      if (!file) return;      
      try {
          setUploadingImage(true);
          const res = await postDataAPI({
          serviceName: "item_data",
          op: "uploadMenuItemImage",
          image: file
        });  
        if (res.status === "ok") {
           setImageName(res.data.image_name);
            setRemoveImage(false);
            // Preview immediately
            setPreviewImage(URL.createObjectURL(file));
        }  
        if (res.status === "error") {
          alert(res.message);
        }
      } finally {
          setUploadingImage(false);
      }
  };

  const handleDeleteImage = () => {
    setPreviewImage("");
    setImageName("");
    setRemoveImage(true);
  };


  const handleSave = () => {
    if (!script.trim()) {
      alert("Coaching script is required");
      return;
    }
    
    setSaving(true);

    const payload = {
      serviceName: "item_data",
      op: "create_update_flash_card",
      item_id: card.item_id,
      coching_script: script,
      flash_card_id: card.flash_id,
      dishName: frontText,
    };

    if (removeImage) {
      payload.remove_image = 1;
      payload.image_name = "";
    } else if (imageName) {
      // Only send newly uploaded filename (not the existing full URL)
      payload.image_name = imageName;
    }

    postDataAPI(payload)
      .then((res) => {
        if (res.status === "ok") {
          onSuccess?.();
          toggle();
        } else {
          alert(res.message || "Failed to update flashcard");
        }
      })
      .finally(() => setSaving(false));
  };

  if (!card) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Edit Flashcard</ModalHeader>

      <ModalBody>
        <Label>Front (Dish Name & Category)</Label>
        <Input value={frontText} disabled className="mb-3" />

        <Label>Back (Coaching Script)</Label>
        {/* <Input
          type="textarea"
          rows="8"
          value={script}
          onChange={(e) => setScript(e.target.value)}
        /> */}
        <EditorContent
            editor={editor}
            className="border rounded p-2 mb-3"
            style={{ minHeight: 150 }}
            />

        <Label>Flashcard Image</Label>
        <div className="mb-3">
            <Input
                type="file"
                accept="image/*"
                onChange={(e)=>uploadImage(e.target.files[0])}
            />
            {uploadingImage && (
                <small className="text-primary">
                    Uploading...
                </small>
            )}
            {previewImage && (
                <div className="mt-2 d-flex align-items-start gap-2">
                    <img
                        src={previewImage}
                        alt=""
                        style={{
                            width: 70,
                            borderRadius: 8
                        }}
                    />
                    <Button
                        color="danger"
                        outline
                        size="sm"
                        type="button"
                        onClick={handleDeleteImage}
                        disabled={uploadingImage || saving}
                        title="Delete image"
                    >
                        <i className="ri-delete-bin-line"></i> Delete
                    </Button>
                </div>
            )}
            
        </div>
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving || uploadingImage}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditFlashcardModal;
